<template>
  <el-dialog @close="$emit('update:visible', false)" v-bind="$attrs" title="编辑密码" class="dialog-600" width="500px">
    <el-form ref="form" :model="form" label-width="130px" v-loading="loading" :rules="rules">
      <el-form-item label="账号" prop="username">
        <el-input v-model="form.username" disabled></el-input>
      </el-form-item>
      <el-form-item v-if="!isAdmin" label="旧密码" prop="oldPassword">
        <el-input v-model="form.oldPassword" type="password"></el-input>
      </el-form-item>
      <el-form-item label="新密码" prop="newPassword">
        <el-input v-model="form.newPassword" type="password"></el-input>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="$emit('update:visible', false)">取 消</el-button>
      <el-button type="primary" @click="submit" :loading="loading">提 交</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { toResetPassword as updateApi } from "@/api/account.js";
import EditDialog from "../mixins/EditDialog.js";
export default {
  props: ['isAdmin'],
  mixins: [EditDialog],
  data() {
    var validateEng = (rule, value, callback) => {
      let zmReg = /[A-Za-z]/; // 大小写字母
      let numReg = /[0-9]/; // 数字
      let zfReg = /[^A-Za-z0-9\s]/; // 特殊字符不包含空格
      let complex = 0;
      if (zmReg.test(value)) {
        ++complex;
      }
      if (numReg.test(value)) {
        ++complex;
      }
      if (zfReg.test(value)) {
        ++complex;
      }
      if (complex < 2) {
        // 密码需包含字母，符号或者数字中至少两项
        callback(new Error("密码需包含字母，符号或者数字中至少两项"));
      } else {
        callback();
      }
    };
    return {
      updateApi: (f) => {
        return updateApi({
          id: f.id,
          oldPassword: f.oldPassword,
          newPassword: f.newPassword
        })
      },
      rules: {
        oldPassword: [
          { required: true, message: "请输入旧密码", trigger: "blur" },
          { min: 6, message: "密码需要在长度在6位以上", trigger: "blur", },
          { validator: validateEng, trigger: "blur" }],
        newPassword: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          { min: 6, message: "密码需要在长度在6位以上", trigger: "blur", },
          { validator: validateEng, trigger: "blur" },],
      },
    };
  },
};
</script>